import React, { useState, useEffect, useRef } from 'react';
import { formatNumber } from '@debbie/common/dist';
import { parseNum } from '@debbie/common/dist/util';
import Input from './Input';
const isNum = (num) => {
    return num != null && typeof num === 'number' && Number.isFinite(num);
};
const MoneyInput = (props) => {
    var _a;
    const seperator = (_a = props.seperator) !== null && _a !== void 0 ? _a : ',';
    const thousandsSeperator = seperator == '.' ? ',' : '.';
    const [userText, setUserText] = useState(isNum(props.value) ? formatNumber(props.value, seperator) : '');
    const [amount, setAmount] = useState(props.value);
    const [errors, setErrors] = useState([]);
    const [cursorLoc, setCursorLoc] = useState(0);
    const [setLoc, setSetLoc] = useState(false);
    const ref = useRef();
    useEffect(() => {
        if (props.value != amount) {
            setAmount(props.value);
            setUserText(isNum(props.value) ? formatNumber(props.value, seperator) : '');
        }
    }, [props.value]);
    useEffect(() => {
        if (ref.current != null && setLoc) {
            ref.current.setSelectionRange(cursorLoc, cursorLoc);
            setSetLoc(false);
        }
    }, [setLoc]);
    return (React.createElement(Input, Object.assign({ inputRef: ref }, props, { value: userText, onChange: (e) => {
            const constraints = [
                (val) => /^-?([0-9.,])*$/.test(val),
                (val) => val.split(seperator).length <= 2,
                (val) => {
                    const splitValue = val.split(seperator);
                    if (splitValue.length < 2) {
                        return true;
                    }
                    return (splitValue[1].length <= 2 &&
                        !splitValue[1].includes(thousandsSeperator));
                },
            ];
            if (constraints.find((constraint) => !constraint(e.target.value)) == null) {
                setErrors([]);
                const num = parseNum(e.target.value, seperator);
                if (Number.isNaN(num)) {
                    if (e.target.value != '') {
                        setErrors(['Not a valid number']);
                    }
                    if (props.allowNull) {
                        setAmount(null);
                        props.onChange(null);
                    }
                    else {
                        setAmount(NaN);
                        props.onChange(NaN);
                    }
                    setUserText(e.target.value);
                }
                else {
                    const originalNum = Math.round(num * 100);
                    let checkedNum = originalNum;
                    if (props.max != null && checkedNum > props.max) {
                        checkedNum = props.max;
                    }
                    if (props.min != null && checkedNum < props.min) {
                        checkedNum = props.min;
                    }
                    if (checkedNum == originalNum) {
                        // Thousands seperators only handled in here
                        const index = e.target.selectionStart;
                        const prevBeforeCursor = e.target.value.slice(0, index);
                        const tSepsBeforeCursor = Math.max(0, prevBeforeCursor.split(thousandsSeperator).length - 1);
                        let newValue = e.target.value.split(thousandsSeperator).join('');
                        const negative = checkedNum < 0;
                        const firstPart = newValue.split(seperator)[0];
                        let newIndex = index - tSepsBeforeCursor;
                        for (let i = firstPart.length - 3; i > (negative ? 1 : 0); i -= 3) {
                            if (i < newIndex) {
                                newIndex += 1;
                            }
                            newValue = newValue.slice(0, i) + '.' + newValue.slice(i);
                        }
                        setUserText(newValue);
                        setCursorLoc(newIndex);
                        setSetLoc(true);
                    }
                    else {
                        setUserText(formatNumber(checkedNum, seperator));
                    }
                    setAmount(checkedNum);
                    props.onChange(checkedNum);
                }
            }
        }, success: userText != ''
            ? props.value != null && !Number.isNaN(props.value)
            : undefined, validationErrors: errors })));
};
export default MoneyInput;
//# sourceMappingURL=MoneyInput.js.map